"use strict";

let findExistingView = require('./findExistingView');
let calculateRedirectUrl = require('./calculateRedirectUrl').init(findExistingView.allowedRedirectDomain(), findExistingView.webUrl());
let ajaxWrapper = require('./ajaxWrapper');
let generalErrorMessage = 'Something has gone wrong. Please try again later.';

const findExistingSuccess = data => {
    if (data && data.successful) {
        window.location.assign("/register-existing?redirect=" + calculateRedirectUrl.calculate());
    } else {
        findExistingView.showErrorMessage(data.message || generalErrorMessage);
    }
};

const findExistingFailure = () => findExistingView.showErrorMessage(generalErrorMessage);

const submitFindExistingForm = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    findExistingView.enableCardNumberField();
    findExistingView.hideServerSideErrors();

    if (findExistingView.isFormDataValid()) {
        const siteKeyEl = document.getElementById("site-key");
        if (siteKeyEl) {
            const siteKey = siteKeyEl.value;
            let action = 'EXISTING_MEMBER_REGISTRATION';
            document.getElementById("reCaptchaAction").value = action;
            document.getElementById("reCaptchaToken").value = await window.grecaptcha.enterprise.execute(siteKey, {action: action});
        }

        const urlEncodedData = findExistingView.getFormObject();

        findExistingView.disableLinkAccountButton();
        ajaxWrapper.call({
            type: "POST",
            url: "/find-existing/verify/ajax",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;'
            },
            data: urlEncodedData,
            success: findExistingSuccess,
            failure: findExistingFailure,
            beforeSend: function () {
                findExistingView.addSpinner();
            },
            complete: function () {
                findExistingView.removeSpinner();
                findExistingView.enableLinkAccountButton();
            }
        });
    }
};

module.exports = {
    initialize: () => findExistingView.onFindExistingFormSubmitted(submitFindExistingForm)
};
